import React from 'react';
import { AEMContent } from '@mlc/web-ui-toolkit';

const Note: React.FunctionComponent = () => {
	return (
		<React.Fragment>
			<AEMContent path="/secure/_content/Adviser/plan-profile/member-demographics/disclaimer" />
		</React.Fragment>
	);
};

export default Note;
